/**
 * About component for the React application.
 * Displays quotes, images, team members, and a contact button linking to the Contact page.
 *
 * Author: Meng li, Jennifer Tran
 * Created on: 2024-10-16
 * Last modified: 2025-01-26
 * Professor: Mejdi Eraslan
 * Client: Melisa Eraslan
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { MissionVisionSection, ValuesSection } from '../components/MissionVisionValues';
import '../../assets/css/About.css';
import '../styles/Global.css';
import '../styles/Reusable.css';

// Image imports
import innovate from '../images/About/clipart_innovate.png';
import saleena from '../images/About/portait_saleena_gul_arif.png';
import ashlyn from '../images/About/portrait_ashlyn_beecroft.png';
import melisa from '../images/About/portrait_melisa_eraslan.png';
import ria from '../images/About/portrait_ria_fazulbhoy.png';
import tents from '../images/About/real_contact_us.jpg';

// Component sections
const InnovateSection = () => {
    return (
        <div className="innovate-section">
            <div className="left-section">
                <img src={innovate} alt="People building a home" />
            </div>
            <div className="right-section">
                <h2 className="h2 title-text">We innovate for better lives.</h2>
                <p className="p card-text">
                    We continuously innovate and adapt our solutions to address the evolving needs of Montreal and
                    Ottawa's homeless community, striving for meaningful impact and positive change.
                </p>
            </div>
        </div>
    );
};

const TeamSection = () => {
    const TeamMember = ({ image, jobTitle, name, achievements }) => (
        <div className="profile">
            <div className="image-wrapper">
                <img src={image} alt={name} />
            </div>
            <div className="title-wrapper">
                <p className="p title-job">{jobTitle}</p>
            </div>
            <h3 className="h3 name">{name}</h3>
            <ul>
                {achievements.map((achievement, index) => (
                    <li key={index}>{achievement}</li>
                ))}
            </ul>
        </div>
    );

    const TEAM_DATA = [
        {
            image: melisa,
            jobTitle: "Executive Director",
            name: "Melisa Eraslan",
            achievements: [
                "Firsthand experience working at shelters & with unhoused individuals",
                "Passionate about social change & sustainability"
            ]
        },
        {
            image: ashlyn,
            jobTitle: "Director of Operations",
            name: "Ashlyn Beecroft",
            achievements: [
                "Master's degree in digital health",
                "Experience working for non-profit organizations"
            ]
        },
        {
            image: ria,
            jobTitle: "Director of Communications",
            name: "Ria Fazulbhoy",
            achievements: [
                "Master's degree in Biotechnology",
                "Experience working with underprivileged communities"
            ]
        },
        {
            image: saleena,
            jobTitle: "Medical Director",
            name: "Saleena Gul Arif",
            achievements: [
                "Medical Doctor",
                "Works with patients experiencing homelessness"
            ]
        }
    ];

    return (
        <div className="team-section">
            <h2 className="h2 title-text">Meet Our Team</h2>
            <div className="profiles">
                {TEAM_DATA.map((member, index) => (
                    <TeamMember key={index} {...member} />
                ))}
            </div>
        </div>
    );
};

const ContactSection = () => {
    return (
        <div className="contact-section">
            <Link to="/contact">
                <button className="btn btn-secondary contact-btn">Contact Us</button>
            </Link>
            <img src={tents} alt="Tents for the homeless" />
        </div>
    );
};

// Main About component
const About = () => {
    return (
        <div className="about-page">
            <MissionVisionSection />
            <ValuesSection />
            <InnovateSection />
            <TeamSection />
            <ContactSection />
        </div>
    );
};

export default About;

